import type { FaireProductEntity } from "../../entity_types/product";

export const p_7gxspth2pe: FaireProductEntity = {
  token: "p_7gxspth2pe",
  type: "product",
  name: "Pink Stripe / Ribbed Gown",
  brandToken: "b_hpgmw3yct2",
  brandName: "SIIX Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/843b8cd40344528dbaf5df3bc2f83ab9a57cddae183794d6c4995ac4ae10515b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df0c8b26ba776883acffb60244c8616b4c67100f110179660433173e59f49bb4.png",
    "https://cdn.faire.com/fastly/a9a51f88d1949c2b98b3dd08db317c4abec59b7719db997b6a5b2826c4b9e50d.png",
  ],
  priceDollars: 12,
  description:
    "Wrap your little one in everyday comfort with our Cotton Ribbed Collection, thoughtfully crafted for softness you can feel from the very first wear. Made from breathable cotton with a cozy ribbed texture, each piece offers a gentle, flexible fit that’s perfect for delicate skin and all-day play. Designed in thoughtfully curated classic stripe patterns, this collection is made for effortless daily wear and lasting comfort.\n\nFabric Details: 95% Cotton / 5% Spandex\n\nFor best results, we recommend washing cold and line drying to help preserve softness and minimize shrinkage.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:35.852Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
